// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nx-0";
export var assigneeDetails = "_nx-1";
export var assigneeInfo = "_nx-2";
export var dropdownContainer = "_nx-4";
export var dropdownImage = "_nx-5";
export var editAssigneeInfo = "_nx-3";
export var editAssigneeModalContainer = "_nx-6";
export var hidden = "_nx-8";
export var input = "_nx-7";